import { PropsWithChildren, useMemo } from 'react'

import { PriceIndexChartContext } from './contexts/StoreContext'
import { PriceIndexChartStoreProviderProps } from './interface'
import { createPriceIndexChartStore } from './store/createStore'

export const PriceIndexChartStoreProvider = ({
  /* -------------------------------------------------------------------------- */
  /*                           PriceIndexChartOptions                           */
  /* -------------------------------------------------------------------------- */
  priceIndexType,

  children
}: PropsWithChildren<PriceIndexChartStoreProviderProps>) => {
  const store = useMemo(
    () => createPriceIndexChartStore({ priceIndexType }),
    [priceIndexType]
  )

  return (
    <PriceIndexChartContext value={store}>{children}</PriceIndexChartContext>
  )
}
